












import { Component, Prop, Vue } from "vue-property-decorator";
import Company from "@/models/Company";
import VSignPost from "@/components/Company/VSignPost.vue";
import VMiniLogo from "@/components/VMiniLogo.vue";

@Component({
  components: {
    VMiniLogo,
  },
})
export default class EntryList extends Vue {
  @Prop() readonly title?: string;
  @Prop({ default: "small" }) readonly size?: string;
  @Prop() readonly items!: Company[];
  @Prop({ default: false }) readonly selectable?: boolean;

  select(value: Company) {
    if (this.selectable === false) {
      return;
    }

    this.$emit("selected", value);
  }

  logoPath(value: Company) {
    return VSignPost.removeHeadingBackSlash(value.croppedLogo || "");
  }

  getWrapperClass() {
    const classes: string[] = [];

    classes.push(`entry-list--${this.size}`);

    if (this.selectable) {
      classes.push("entry-list--selectable");
    }

    return classes;
  }
}
